import config from "./config"
import api from './api'
import tool from './utils/tool'
import http from "./utils/request"
import { permission, rolePermission } from './utils/permission'
import * as elIcons from '@element-plus/icons-vue'
import ComTable from '@/components/comTable'
import ComTableColumn from '@/components/comTable/column.js'
import Breadcrumb from '@/components/breadcrumb'
import CreateSections from '@/components/CreateSections'
import TableSearchBar from '@/components/tableSearchBar'
import ComSelect from '@/components/form/comSelect'
import TableHeader from '@/components/tableHeader'
import ComUploadSingle from '@/components/comUpload'
import ComUploadFile from '@/components/comUpload/file'
import ComUploadMultiple from '@/components/comUpload/multiple'
import RightSlider from '@/components/rightSlider'

const components = [ComTable,ComTableColumn,Breadcrumb,CreateSections,TableSearchBar,ComSelect,TableHeader,ComUploadSingle,ComUploadFile,ComUploadMultiple,RightSlider]

export default {
  install(app) {
    //挂载全局对象
		app.config.globalProperties.$CONFIG = config;
		app.config.globalProperties.$TOOL = tool;
		app.config.globalProperties.$HTTP = http;
		app.config.globalProperties.$API = api;
		app.config.globalProperties.$AUTH = permission;
		app.config.globalProperties.$ROLE = rolePermission;

		//注册全局组件
		components.map(component => {
			if (component && component.install) {
					component.install(app)
			} else if (component) {
					app.component(component.name, component)
			}
		})

		//统一注册el-icon图标
		for(let icon in elIcons){
			app.component(`ElIcon${icon}`, elIcons[icon])
		}
  }
}